import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { LoginPage } from './login';
import { ReactiveFormsModule } from "@angular/forms";

@NgModule({
  declarations: [
    LoginPage,
  ],
  imports: [
    IonicPageModule.forChild(LoginPage),
    ReactiveFormsModule,
  ],
  exports: [
    LoginPage
  ]
})
export class LoginPageModule {}


// WEBPACK FOOTER //
// ./src/pages/login/login.module.ts